// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-multiselect-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: normal;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    outline: none;
    gap: 10px !important;
}

.p-multiselect-items {
    margin: 0;
    padding: 0 !important;
    list-style-type: none;
}
.p-checkbox.p-highlight .p-checkbox-box {
    border-color: #02351c !important;
    background: #02351c !important;
}
.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
    color: #495057 !important;
    background: #0f723b3b !important;
}
.p-multiselect-select-all {
    display: flex;
    align-items: center;
    gap: 10px;
}
.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box{
    border-color: #02351c !important;
}
.p-multiselect:not(.p-disabled).p-focus {
    box-shadow: 0 0 0 0.1rem #02351c;
}
.form-select:focus {
    border-color: #02351c !important;
    box-shadow: 0 0 0 0.1rem #02351c !important;
}
.p-inline-message {
    padding: 0.5rem 0 !important;
    margin: 0px 0px 15px !important
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/appointmentScheduler/appointment.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;IAChC,2CAA2C;AAC/C;AACA;IACI,4BAA4B;IAC5B;AACJ","sourcesContent":[".p-multiselect-item {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    font-weight: normal;\n    white-space: nowrap;\n    position: relative;\n    overflow: hidden;\n    outline: none;\n    gap: 10px !important;\n}\n\n.p-multiselect-items {\n    margin: 0;\n    padding: 0 !important;\n    list-style-type: none;\n}\n.p-checkbox.p-highlight .p-checkbox-box {\n    border-color: #02351c !important;\n    background: #02351c !important;\n}\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {\n    color: #495057 !important;\n    background: #0f723b3b !important;\n}\n.p-multiselect-select-all {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box{\n    border-color: #02351c !important;\n}\n.p-multiselect:not(.p-disabled).p-focus {\n    box-shadow: 0 0 0 0.1rem #02351c;\n}\n.form-select:focus {\n    border-color: #02351c !important;\n    box-shadow: 0 0 0 0.1rem #02351c !important;\n}\n.p-inline-message {\n    padding: 0.5rem 0 !important;\n    margin: 0px 0px 15px !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
